/* ============================================================
   COLLECTION PAGE VARIANT PICKER - JavaScript (Impulse Theme)
   ============================================================
   File: assets/collection-variant-picker.js
   ============================================================ */

(function () {
  'use strict';

  function initVariantPickers() {
    document.querySelectorAll('.coll-variant-picker').forEach(initPicker);
  }

  function initPicker(picker) {
    if (picker.dataset.initialized === 'true') return;
    picker.dataset.initialized = 'true';

    var dataEl = picker.querySelector('.coll-variant-data');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Variant picker: invalid JSON', e);
      return;
    }

    var card = picker.closest(
      '.grid-product, .grid__item, .product-card, .card, [class*="grid-product"], [class*="product-card"]'
    );
    if (!card) return;

    // Find image - Impulse uses image-element render
    var cardImage = card.querySelector(
      '.grid-product__image-mask img, .grid__image-ratio img, .image-wrap img, .grid-product__image, img'
    );

    // Build option index map: which index is color, which is size
    var colorIndex = null;
    var sizeIndex = null;
    var colorNames = ['color', 'colour', 'couleur'];
    var sizeNames = ['size', 'taille', 'pointure'];

    data.optionNames.forEach(function (name, i) {
      var lower = name.toLowerCase();
      if (colorNames.indexOf(lower) !== -1) colorIndex = i;
      if (sizeNames.indexOf(lower) !== -1) sizeIndex = i;
    });

    // Track selected options
    var selected = {};
    data.optionNames.forEach(function (name, i) {
      var firstActiveBtn = picker.querySelector(
        '.coll-swatch--active[data-option-index="' + i + '"]'
      );
      if (firstActiveBtn) {
        selected[i] = firstActiveBtn.dataset.optionValue;
      }
    });

    // On initial load: update size availability based on first selected color
    if (colorIndex !== null && sizeIndex !== null && selected[colorIndex]) {
      updateAvailability(picker, data, selected, colorIndex, sizeIndex);
    }

    // Attach click handlers
    picker.querySelectorAll('.coll-swatch').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var optionIndex = parseInt(btn.dataset.optionIndex);
        var optionValue = btn.dataset.optionValue;
        var optionType = btn.dataset.optionType;

        // Update active state in same group
        var siblings = picker.querySelectorAll(
          '.coll-swatch[data-option-index="' + optionIndex + '"]'
        );
        siblings.forEach(function (s) { s.classList.remove('coll-swatch--active'); });
        btn.classList.add('coll-swatch--active');

        // Update selected
        selected[optionIndex] = optionValue;

        // Update image when color changes
        if (optionType === 'color' && btn.dataset.variantImage && cardImage) {
          updateImage(cardImage, btn.dataset.variantImage, card);
        } else {
          // Try to find a matching variant image
          var matchedVariant = findVariant(data, selected);
          if (matchedVariant && matchedVariant.image && cardImage) {
            updateImage(cardImage, matchedVariant.image, card);
          }
        }

        // Update cross-option availability
        if (colorIndex !== null && sizeIndex !== null) {
          if (optionType === 'color') {
            // Color changed → update which sizes are available
            updateAvailability(picker, data, selected, colorIndex, sizeIndex);
          } else if (optionType === 'size') {
            // Size changed → update which colors are available
            updateAvailability(picker, data, selected, sizeIndex, colorIndex);
          }
        }
      });
    });
  }

  /**
   * Update availability of the "other" option based on the "changed" option
   * E.g., if color changed, update size availability for that color
   */
  function updateAvailability(picker, data, selected, changedIndex, otherIndex) {
    var changedValue = selected[changedIndex];
    var otherButtons = picker.querySelectorAll(
      '.coll-swatch[data-option-index="' + otherIndex + '"]'
    );

    otherButtons.forEach(function (btn) {
      var otherValue = btn.dataset.optionValue;

      // Check if ANY variant with this combination exists and is available
      var isAvailable = data.variants.some(function (v) {
        return (
          v.options[changedIndex] === changedValue &&
          v.options[otherIndex] === otherValue &&
          v.available
        );
      });

      btn.classList.toggle('coll-swatch--unavailable', !isAvailable);
    });
  }

  function findVariant(data, selected) {
    return data.variants.find(function (variant) {
      return data.optionNames.every(function (name, i) {
        if (!selected[i]) return true;
        return variant.options[i] === selected[i];
      });
    });
  }

  function updateImage(imgEl, newSrc, card) {
    // Handle srcset
    if (imgEl.srcset) {
      var baseUrl = newSrc.replace(/&width=\d+/, '');
      var widths = [180, 360, 540, 720, 900, 1080];
      var newSrcset = widths
        .map(function (w) { return baseUrl + '&width=' + w + ' ' + w + 'w'; })
        .join(', ');
      imgEl.srcset = newSrcset;
    }

    imgEl.src = newSrc;

    // Update lazy load attributes (Impulse uses lazysizes)
    if (imgEl.dataset.src) imgEl.dataset.src = newSrc;
    if (imgEl.dataset.srcset) {
      var baseUrl = newSrc.replace(/&width=\d+/, '');
      var widths = [180, 360, 540, 720, 900, 1080];
      imgEl.dataset.srcset = widths
        .map(function (w) { return baseUrl + '&width=' + w + ' ' + w + 'w'; })
        .join(', ');
    }

    // Hide Impulse's hover image briefly so it doesn't flash
    if (card) {
      var secondaryImg = card.querySelector('.grid-product__secondary-image');
      if (secondaryImg) {
        secondaryImg.style.opacity = '0';
        setTimeout(function () { secondaryImg.style.opacity = ''; }, 300);
      }
    }

    // Fade effect
    imgEl.style.opacity = '0';
    requestAnimationFrame(function () {
      imgEl.style.transition = 'opacity 0.25s ease';
      imgEl.style.opacity = '1';
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPickers);
  } else {
    initVariantPickers();
  }

  document.addEventListener('shopify:section:load', initVariantPickers);

  // MutationObserver for infinite scroll / AJAX pagination
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType === 1 && node.querySelectorAll) {
          node.querySelectorAll('.coll-variant-picker').forEach(initPicker);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();